import {
  CarehomeTeamMemberData,
  CarehomeStaff,
} from '@typings/TeamMemberTypes';
import { ApiResponse, ApiResponseArray } from '@typings/ApiResponse';
import { TeamMemberInfo } from '@components/team-member/edit-team-member/utils';
import { axiosIns } from './index';

const inviteTeamMember = async (
  full_name: string,
  email: string,
  role: string,
  partner_carehome_id: string
): Promise<ApiResponse<CarehomeStaff | string>> => {
  const response = await axiosIns.post('/carehome/member/invite', {
    full_name,
    email,
    role,
    partner_carehome_id,
  });
  return response.data;
};

const getTeamMembers = async (
  id: string
): Promise<ApiResponseArray<CarehomeTeamMemberData>> => {
  const response = await axiosIns.get(`/carehome/partner/members/${id}`);
  return response.data;
};

const editTeamMember = async (
  memberId: string,
  role: string,
  carehomePartnerId: string,
  memberInfo: TeamMemberInfo
): Promise<ApiResponseArray<CarehomeStaff | string>> => {
  const { speciality, teamName, jobTitle } = memberInfo;
  const response = await axiosIns.put(`carehome/member/${memberId}`, {
    role,
    carehome_partner_id: carehomePartnerId,
    speciality,
    team_name: teamName,
    job_title: jobTitle,
  });
  return response.data;
};

const getMemberInfo = async (
  memberId: string,
  carehomeId: string
): Promise<ApiResponse<CarehomeTeamMemberData>> => {
  const response = await axiosIns.get('/carehome/member/info', {
    params: {
      staff_id: memberId,
      carehome_id: carehomeId,
    },
  });
  return response.data;
};

const removeTeamMember = async (
  memberId: string,
  partnerCarehomeId: string
) => {
  const response = await axiosIns.post(`/carehome/member/remove/${memberId}`, {
    partner_id: partnerCarehomeId,
  });
  return response.data;
};

export {
  inviteTeamMember,
  getTeamMembers,
  editTeamMember,
  removeTeamMember,
  getMemberInfo,
};
